import React, { useState, useEffect } from 'react';
import { debounce } from '../../../utils/web-helper';

const useResize = () => {
  const [isClient, setIsClient] = useState(false);
  // is client check is for SSR as we dont have window object in ssr rendering
  const [dimensions, setDimensions] = useState({
    height: isClient ? window.innerHeight : 0,
    width: isClient ? window.innerWidth : 0,
  });
  useEffect(() => {
    // useEffect is only initiated on client machine hence making isClient check true and returning proper width and height
    setIsClient(() => true);
    handleResize();
    const debouncedResize = debounce(handleResize, 50);
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.addEventListener('resize', debouncedResize);
    };
  }, []);
  function handleResize() {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  }
  return isClient
    ? dimensions
    : {
        height: 0,
        width: 0,
      };
};

export default useResize;
